export default {
  widgetTitleConnexion: 'Portail Client',
  widgetTitleMultiFacteur: 'Authentification MultiFacteur',
  widgetTitleOktaVerify: 'Okta Verify',
  widgetTitleWindowsHello: 'Windows Hello',
  widgetTitleGoogleAuthenticator: 'Identification par application mobile',
  widgetTitleSmsCall: 'Identification par téléphone',
  widgetTitleExpiredPassword: 'Mot de passe temporaire',
  loginError: 'Le nom d\'utilisateur ou le mot de passe est incorrect.',
  loginErrorCounter: 'Veuillez nous joindre pour obtenir de l\'aide.',
  forgotUsername: 'Nom d\'utilisateur oublié?',
  username: 'Nom d\'utilisateur',
  remember: 'Mémoriser le nom d\'utilisateur',
  signInButton: 'Me connecter',
  signUpButton: 'Créer un compte',
  mfaChoiceButton: 'Choisir',
  mfaChoiceDescription: 'Vous devez activer un facteur d\'authentification afin d\'ajouter une couche de sécurité supplémentaire lors de la connexion à votre compte.',
  mfaGoogleChoiceDescription: 'Utiliser l\'application mobile pour vous authentifier.',
  mfaOktaVerifyChoiceDescription: 'Utiliser l\'application mobile Okta Verify pour vous authentifier.',
  back: 'Précédent',
  passwordExpiredSubmit: '{0}r',
  passwordExpiredSubtitle: 'Par mesure de sécurité, vous devrez définir un nouveau mot de passe à l\'étape suivante.',
  mandatoryMessage: 'Champ obligatoire',
  forgotPassword: 'Mot de passe oublié?',
  cancel: 'Retour à la page de connexion',
  'factor.call.description': 'Vérification via un code envoyé par message vocal sur votre téléphone.',
  'enroll.totp.setupGoogleAuthApp': 'Lancez {0}, tapez sur l\'icône «+», puis sélectionnez «Scanner un code QR».',
  'enroll.totp.cannotScan': 'Impossible de numériser ?',
  'enroll.totp.cannotScanBarcode': 'Vous n\'arrivez pas à numériser le code QR ?',
  'enroll.totp.manualSetupInstructions': 'Pour procéder une configuration manuelle, saisissez le nom d\'utilisateur de votre compte, puis saisissez ce qui suit dans le champ Clé secrète.',
  'enroll.totp.enterCode': 'Saisissez le code affiché sur l\'application.',
  'mfa.challenge.enterCode.placeholder': 'Saisir le code',
  'mfa.challenge.enterCode.tooltip': 'Saisir le code',
  'factor.sms.description': 'Vérification via un code envoyé par message texte sur votre téléphone.',
  'factor.sms.time.warning': 'Vous n\'avez pas reçu le code par message texte ? ',
  'phone.extention.label': 'Poste',
  'mfa.phoneNumber.ext.placeholder': 'Poste',
  'factor.call.time.warning': 'Vous n\'avez pas reçu d\'appel vocal ? ',
  'enroll.totp.setupApp': 'Lancez {0} sur votre appareil mobile et sélectionnez « Ajouter un compte ». Numérisez le code QR pour continuer.',
  'enroll.choices.optional': 'Vous pouvez configurer tout facteur facultatif supplémentaire ou cliquer sur Terminer',
  'mfa.redial': 'Rappeler',
  'mfa.sendCode': 'Recevoir un code par message texte',
  'mfa.resendCode': 'Renvoyer le code',
  'mfa.calling': 'Appel en cours',
  'rememberDevice.timebased': 'Ne plus me vérifier sur cet appareil pendant {0}',
  'oform.errorbanner.title': 'Nous avons trouvé quelques erreurs. Veuillez examiner le formulaire et effectuer les corrections adéquates.',
  'mfa.challenge.subtitle.call': 'M\'envoyer un code par appel vocal au ',
  'mfa.challenge.subtitle.sms': 'M\'envoyer un code par message texte au ',
  'mfa.challenge.subtitle.email': 'M\'envoyer un code par courriel au ',
  'email.mfa.call.sent.description': 'Un code de vérification a été envoyé à {0}',
  'email.mfa.sms.sent.description': 'Un code de vérification a été envoyé à {0}',
  'email.code.not.received': 'Vous n\'avez pas reçu le code par courriel ? ',
  'email.button.resend': 'Renvoyez le code',
  'mfa.call': 'Recevoir un code par appel vocal',
  'email.mfa.title': 'Authentification par courriel',
  'email.mfa.description': 'Envoyez-moi un code par courriel à {0}',
  'email.button.send': 'Recevoir un code par courriel',
  'email.mfa.email.sent.description': 'Un code de vérification a été envoyé à {0}',
  'email.code.label': 'Saisir le code',
  'factor.email': 'Authentification par courriel',
  'factor.sms': 'Authentification par message texte',
  'factor.call': 'Authentification par appel vocal',
  'enroll.sms.setup': 'Recevoir un code par message texte pour l\'authentification',
  'enroll.totp.title': 'Configurez {0}',
  'model.validation.field.blank': 'Champ obligatoire',
  'enroll.choices.list.enrolled': 'Facteurs configurés',
  'enroll.totp.sendSms': 'Envoyer le lien d\'activation par message texte',
  'enroll.totp.sendEmail': 'Envoyer le lien d\'activation par courriel',
  'enroll.totp.setupManually': 'Procéder à une configuration manuelle avec clé secrète',
};
